import User from 'records/User';
import Button from '@material-ui/core/Button';
import React from 'react';
import FileField from 'components/pure/utils/form/FileField';
import UserAvatar from 'components/pure/utils/UserAvatar';

export default function AvatarEditor(props: {
  onChange: (a: any) => void;
  dropzoneOnDrop: (acceptedFiles, rejectedFiles) => void;
  user: User;
  onClick: () => void;
}) {
  return (
    <FileField
      onChange={props.onChange}
      name="avatar"
      className="profile-image-field"
      accept="image/*"
      multiple={false}
      maxSize={4000000} // 4MB
      dropzoneOnDrop={props.dropzoneOnDrop}>
      <div className="form-grouper avatar-edit">
        <div className="avatar-wrapper">
          <UserAvatar user={props.user} sensitive />
        </div>
        <div className="edit-wrapper">
          <Button variant="outlined" onClick={props.onClick}>
            Update Avatar
          </Button>
        </div>
      </div>
    </FileField>
  );
}
